import React from "react";

const reportsData = [
  "Verification of TAN and update as per TAN in master",
  "Online Request on TRACES & ITD Portal",
  "TDS data report for audit",
  "Add Challan directly which paid on ITD portal",
  "Return filed Dashboard",
  "e-Payment Facility at Income Tax Portal for Form 26QB",
  
];

const Reports = () => (
  <div className="relative bg-white pb-20 sm:flex justify-center">
    <div className="sm:flex flex-col justify-between items-center w-full max-w-7xl px-5">
      <div className="sm:w-full text-center pb-5">
        <p
          className="mb-0 text-5xl font-bold bg-clip-text text-transparent"
          style={{
            backgroundImage:
              "linear-gradient(120deg, #686bff 0%, #00b812 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          Other Features
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 sm:w-full gap-5">
        {reportsData.map((report, index) => (
          <div
            key={index}
            className="flex items-strat bg-[#ffffff] shadow-xl px-5 py-5 border-2 rounded-[10px] border-[#b5d0ff] duration-200 hover:scale-105 hover:shadow-2xl"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="#00b812"
              class="bi bi-caret-right-fill"
              viewBox="0 0 16 16"
              className="mt-[6px] mr-2  w-[16px] h-[16px]"
            >
              <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
            </svg>
            <p className="mb-0 text-black font-semibold text-xl">{report}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Reports;
